/* eslint-disable array-callback-return */

import React from 'react';
import { EditorState } from 'draft-js';
import {
  createEmptySelectionState,
  contentStateWithInsertedText,
  getContentStateWithAppliedEntity,
} from 'Shared/utils/draftJsHelpers';

import Emoji from 'Shared/components/DraftEditor/components/EmojiComponent/EmojiComponent';

const EMOJI_ENTITY_TYPE = 'emoji';

const emojiPlugin = {
  decorators: [
    {
      strategy: (contentBlock, callback, contentState) => {
        contentBlock.findEntityRanges(character => {
          const entityKey = character.getEntity();
          return entityKey !== null && contentState.getEntity(entityKey).getType() === EMOJI_ENTITY_TYPE;
        }, callback);
      },
      component: props => <Emoji {...props} />,
    },
  ],
};

function createEmojiEntity(editorState, entityData) {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  const blockKey = selectionState.getFocusKey();
  const blockOffset = selectionState.getFocusOffset();

  const unicode = entityData.emoji.native;

  const selectionForAnchor = createEmptySelectionState(blockKey, blockOffset, blockOffset);
  const contenstStateWithAnchor = contentStateWithInsertedText(contentState, selectionForAnchor, `${unicode} `);

  const selectionStateForEntity = createEmptySelectionState(blockKey, blockOffset, blockOffset + unicode.length);
  const contentStateWithCreatedEntity = getContentStateWithAppliedEntity(
    contenstStateWithAnchor,
    selectionStateForEntity,
    EMOJI_ENTITY_TYPE,
    entityData
  );

  return EditorState.push(editorState, contentStateWithCreatedEntity);
}

function enrichEditorStateByEmoji(editorState, emoji, entityData = {}) {
  if (!emoji) return editorState;

  const editorStateWithEntity = createEmojiEntity(editorState, {
    emoji,
    ...entityData,
  });
  return EditorState.moveFocusToEnd(editorStateWithEntity);
}

export { enrichEditorStateByEmoji, emojiPlugin };
